/**
 * @function parseErrorString
 * @desc Parses an error response string for a JSON object.
 * @access private
 *
 * @param {String} error - the error message
 *
 * @returns {Object} - if JSON object else null;
 */
export function parseErrorString(error: string): object | null {
  const openBracket = error.indexOf('{');
  const closingBracket = error.lastIndexOf('}');
  if (openBracket >= 0 && closingBracket >= 0) {
    try {
      return JSON.parse(error.substring(openBracket, closingBracket + 1));
    } catch (e) {
      return null;
    }
  }

  return null;
}

/**
 * @function parseErrorResponse
 * @desc Parses an errore response from GQL
 * @access public
 *
 * @param {String|Object} response - the error message response.
 *
 * @returns {Object} - if JSON object else null;
 */
export default function parseErrorResponse(
  response: string | object | any
): object | null {
  if (response === null || response === undefined) return null;

  if (typeof response === 'string') {
    return parseErrorString(response);
  }
  if (typeof response.message === 'string') {
    return parseErrorString(response.message);
  }

  return null;
}
